import { combineReducers } from "redux";

import roomReducer, {
  actionCreators as roomActions,
  actionTypes as roomActionTypes,
  initialState as roomInitial,
} from "./room";

import participantsReducer, {
  actionCreators as participantsActions,
  initialState as participantsInitial,
} from "./participants";

import messagesReducer, {
  actionCreators as messagesActions,
  initialState as messagesInitial,
} from "./messages";

import configReducer, {
  actionCreators as configActions,
  initialState as configInitial,
} from "./config";

import authReducer, {
  actionCreators as authActions,
  actionTypes as authActionTypes,
  initialState as authInitial,
} from "./auth";

import { actionCreators as notificationActions } from "./notifications";

const appReducer = combineReducers({
  room: roomReducer,
  participants: participantsReducer,
  messages: messagesReducer,
  config: configReducer,
  auth: authReducer,
});

const rootReducer = (state, action) => {
  if (
    action.type === roomActionTypes.ROOM_LOGOUT ||
    (action.type === authActionTypes.KBPORT_TOKEN && !action.payload.state)
  ) {
    const { config } = state;
    state = { config };
  }
  return appReducer(state, action);
};

export const initialState = {
  room: roomInitial,
  participants: participantsInitial,
  messages: messagesInitial,
  auth: authInitial,
};

export const actionCreators = {
  room: roomActions,
  participants: participantsActions,
  messages: messagesActions,
  notifications: notificationActions,
  auth: authActions,
};

export default rootReducer;
